/**
 * Contact, Chat & Social Endpoint Getters
 * Type-safe path constructors for contact form, chat, and social feature endpoints.
 */

import { getEndpoint } from '../url-builders';
import { API_ENDPOINTS } from './raw';

export const contactEndpoints = {
  submit: () => getEndpoint(API_ENDPOINTS.contact.submit)
} as const;

export const chatEndpoints = {
  send: () => getEndpoint(API_ENDPOINTS.chat.send),
  conversations: () => getEndpoint(API_ENDPOINTS.chat.conversations),
  conversation: (id: string) =>
    `${getEndpoint(API_ENDPOINTS.chat.conversation)}/${id}`,
  socket: () => getEndpoint(API_ENDPOINTS.chat.socket)
} as const;

export const socialEndpoints = {
  toggleFavorite: (campaignId: string) =>
    `${getEndpoint(API_ENDPOINTS.social.favorites)}/${campaignId}/favorite`,
  toggleBookmark: (campaignId: string) =>
    `${getEndpoint(API_ENDPOINTS.social.bookmarks)}/${campaignId}/bookmark`,
  trackShare: (slug: string) =>
    `${getEndpoint(API_ENDPOINTS.social.shares)}/${slug}/share`,
  getTimeline: (slug: string) =>
    `${getEndpoint(API_ENDPOINTS.social.timeline)}/${slug}/donations`
} as const;
